import { createElement } from 'react';
import { TimePicker as OriginalTimePicker } from 'antd';
const TimePicker = function TimePicker({ ...otherProps }) {
    const _otherProps = otherProps || {};
    return (createElement(OriginalTimePicker, { ..._otherProps }));
};
export default TimePicker;
